var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":_vm.onClick}},[(_vm.icon)?_c('vus-icon',{attrs:{"size":16,"icon-class":_vm.icon,"class-name":"vus-btn-icon"}}):_vm._e(),_vm._v(" "),_c('span',{ref:"slot"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/vus-button/vus-button.vue